import React from 'react';
import { AlertTriangle, CheckCircle2, XCircle } from 'lucide-react';

const STATUS = {
  fallo: { label: 'Falla', icon: XCircle, className: 'rp-status-critical', order: 0 },
  aviso: { label: 'Mejorable', icon: AlertTriangle, className: 'rp-status-warning', order: 1 },
  ok: { label: 'Bien', icon: CheckCircle2, className: 'rp-status-good', order: 2 }
};

const TechnicalChecks = ({ report }) => {
  if (report.technical.length === 0) {
    return <p className="text-[var(--lp-muted)]">No se indicó ninguna web, así que no se ha analizado.</p>;
  }

  const checks = [...report.technical].sort((a, b) => STATUS[a.status].order - STATUS[b.status].order);

  return (
    <ul className="grid gap-4 md:grid-cols-2">
      {checks.map((check) => {
        const status = STATUS[check.status];
        const Icon = status.icon;
        return (
          <li key={check.id} className="rp-keep rounded-2xl border border-[var(--lp-line)] p-5">
            <p className="flex items-center gap-2 text-sm font-semibold">
              <Icon size={18} className={status.className} aria-hidden="true" />
              {status.label}
            </p>
            <p className="mt-3 text-lg font-semibold tracking-[-0.01em]">{check.label}</p>
            <p className="mt-1 text-[var(--lp-muted)]">{check.detail}</p>
          </li>
        );
      })}
    </ul>
  );
};

export default TechnicalChecks;
